/**
 *  All api related to pages
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchPage(options = {}) {
  const { method, codeOrId, ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchPage',
    () => source.cancel('fetchPage: Operation cancelled by user')
  )

  let action = ''

  switch (method) {
    case 'code':
      action = 'by_code/'
      break
    case 'slug':
      action = 'by_slug/'
      break
  }

  return OmnitechApi
    .request({
      endpoint: `pages/${action}${codeOrId}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      page: data.page
    }))
}
